import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  public isLoading$: Subject<boolean> = new Subject<boolean>();
  public currentPath$: Subject<string> = new Subject<string>();

  constructor() { }
}
